/* eslint-disable jsx-a11y/control-has-associated-label */

/* eslint-disable react/jsx-no-target-blank */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import styles from '../../../../styles/themes/rhoneacademy/footer-rhoneacademy.module.scss';

import logoFr from '../../../../img/rhoneacademy/brand/fr/logo-horizontal-light.svg';
import logoEn from '../../../../img/rhoneacademy/brand/en/logo-horizontal-light.svg';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function FooterRhoneacademy({
    className,
}) {
    const { locale } = useIntl();

    const localizedLogo = useMemo(() => {
        switch (locale) {
            case 'en':
                return logoEn;

            case 'fr':
            default:
                return logoFr;
        }
    }, [locale]);

    return (
        <footer className={classNames([styles.container, { [className]: className !== null }])}>
            <div className={styles.content}>
                <img className={styles.logo} src={localizedLogo} alt="Logo Vignobles de la vallée du rhône" />
            </div>
        </footer>
    );
}

FooterRhoneacademy.propTypes = propTypes;
FooterRhoneacademy.defaultProps = defaultProps;

export default FooterRhoneacademy;
